@if (label) {
	<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
		{{ label }}
	</ic-label>
}

<div class="pv-select-input" [class.disabled]="disabled" (focusClick)="setFocus()" (keydown.space)="setFocus()">
	@if (icon) {
		<i aria-hidden="true" [ngClass]="[icon, 'icon']"> </i>
	}
	<p
		role="select"
		tabindex="0"
		[class.placeholder]="getSelectedLabel() === placeholder"
		[matTooltip]="info"
		[matTooltipDisabled]="!info"
	>
		<span class="value-wrapper">
			{{ getSelectedLabel() }}
		</span>
		<i aria-hidden="true" class="fa fa-caret-down"></i>
	</p>
</div>
@if (hasFocus) {
	<div class="pv-select-options" data-test="pv-select-options">
		<ul [class.fit-height-to-options]="fitHeightToOptions">
			<ng-content />
		</ul>
	</div>
}
